/* tslint:disable */
/* eslint-disable */
/**
 * Kiwi Framework
 * Kiwi API description
 *
 * The version of the OpenAPI document: 0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MaterialEditRequest
 */
export interface MaterialEditRequest {
    /**
     * 
     * @type {string}
     * @memberof MaterialEditRequest
     */
    materialId: string;
    /**
     * 
     * @type {string}
     * @memberof MaterialEditRequest
     */
    materialType: MaterialEditRequestMaterialTypeEnum;
    /**
     * 
     * @type {Date}
     * @memberof MaterialEditRequest
     */
    availableDate: Date;
}


/**
 * @export
 */
export const MaterialEditRequestMaterialTypeEnum = {
    ClassMaterials: 'class materials',
    Recitation: 'recitation',
    RecitationAnswer: 'recitation answer'
} as const;
export type MaterialEditRequestMaterialTypeEnum = typeof MaterialEditRequestMaterialTypeEnum[keyof typeof MaterialEditRequestMaterialTypeEnum];


/**
 * Check if a given object implements the MaterialEditRequest interface.
 */
export function instanceOfMaterialEditRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "materialId" in value;
    isInstance = isInstance && "materialType" in value;
    isInstance = isInstance && "availableDate" in value;

    return isInstance;
}

export function MaterialEditRequestFromJSON(json: any): MaterialEditRequest {
    return MaterialEditRequestFromJSONTyped(json, false);
}

export function MaterialEditRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): MaterialEditRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'materialId': json['materialId'],
        'materialType': json['materialType'],
        'availableDate': (new Date(json['availableDate'])),
    };
}

export function MaterialEditRequestToJSON(value?: MaterialEditRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'materialId': value.materialId,
        'materialType': value.materialType,
        'availableDate': (value.availableDate.toISOString()),
    };
}

